import { render } from "./node.vue?vue&type=template&id=49516e7a"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\avue\\avue3.0\\avue\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.27_typescript@5.9.3__webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/element-plus/flow/node.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49516e7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49516e7a', __exports__)) {
    console.log('reload')
    api.reload('49516e7a', __exports__)
  }
  
  module.hot.accept("./node.vue?vue&type=template&id=49516e7a", () => {
    console.log('re-render')
    api.rerender('49516e7a', render)
  })

}


export default __exports__